import { usersRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { ChangePasswordJson } from '../types';

export const useChangePassword = () =>
  useMutation<ApiResponse<unknown>, unknown, ChangePasswordJson>(
    (changePassword) => usersRepo.changePassword(changePassword),
  );
